/* eslint-disable no-console */
import type { Env, LogLevel } from 'types';

const LOG_LEVELS: LogLevel[] = ['info', 'warning', 'error'];

function readEnv<K extends keyof Env>(key: K): Env[K] | undefined {
  if (typeof window !== 'undefined') return window.env?.[key];

  return process.env[key] as Env[K] | undefined;
}

function getMinLevel(): LogLevel | undefined {
  const configured = readEnv('LOG_LEVEL');

  return configured && LOG_LEVELS.includes(configured) ? configured : undefined;
}

function shouldLog(level: LogLevel): boolean {
  const minLevel = getMinLevel();
  if (!minLevel) return false;

  return LOG_LEVELS.indexOf(level) >= LOG_LEVELS.indexOf(minLevel);
}

export const log = {
  error(...args: unknown[]) {
    if (shouldLog('error')) console.error(...args);
  },
  info(...args: unknown[]) {
    if (shouldLog('info')) console.info(...args);
  },
  warning(...args: unknown[]) {
    if (shouldLog('warning')) console.warn(...args);
  }
};
